export const GET_VENUE = 'get-venue';
const getVenue = ({ slug, routingStyle }) => (
  {
    type: GET_VENUE,
    payload: { slug, routingStyle },
  }
);
export default getVenue;
